import isElectron from 'is-electron'

export const version = '1.0.2'  // 记录当前终端版本，上线修改

// 版本更新不刷新的页面配置  配置规则， 根据vue 页面得 路径做 匹配，匹配到的页面在版本更新时不进行刷新操作
// 如果希望停留在某个页面的时候这个页面不自动更新可以在这里配置 ，加上路由就可以
// export const zhNoReloadPage = 'orderDirectory nursingTask oldpeopleNursingTask choose ';
export const zhNoReloadPage = '';
export const zhNoShowBannerPage = 'oldpeopleConcernExamine outRecordStatisticsDetail outRecordStatistics homeSiteSignIn';
let API_HOST_STR = ''
let API_HOST_FZK_STR = ''
let API_HOST_DPC_STR = ''


// 判断是否时electron 端， 如果是采用 域名 + uri  的模式
if(isElectron()) {
  API_HOST_STR =  'http://yhylhthome.yhylht.cn'
  API_HOST_FZK_STR =  'http://fuzhika.yhylht.cn'
  API_HOST_DPC_STR =  'http://nbdpc.yhylht.cn'
}


export const API_HOST = API_HOST_STR
export const API_HOST_FZK = API_HOST_FZK_STR
export const API_HOST_DPC = API_HOST_DPC_STR



// WEBPACK FOOTER //
// ./src/config/index.js